import OfferCritDetails from './OfferCritDetails';

export type { IOfferCritDetailsHandle } from './OfferCritDetails';
export default OfferCritDetails;
